<template>
    <div>
        <div class="breadcrumb-layout" name="head-block">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>巡查记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout" name="tree-block">
            <swb-popover-org-tree :showMgmt="true" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btn-block">
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="doExport">导出列表</div>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg} from '../../app.vues'

    import appConf from '../../app.conf';
    import {checkUserActionPerm} from '../index'
    import {setAssetsGroupDevcFilter} from '../asset/selectDlg'
    import {getDefaultPageSizes, getDefaultDownloadPageSize} from '../../../src/app.conf'
    import {openAsserStockCheckContrastDlg} from './selectDlg'
    import {showGrpDownloadDlg} from '../ctrl/dialog'
    import {loadRetailerDevcGroupCascList, loadRetailerShopTagList} from '../retailer/asset-comn'
    import {openBigImgDlg} from '../comn/dialog'

    import shopDevcApi from '../../api/shopDevc';
    import userApi from '../../api/user';
    import retailerApi from '../../api/retailer'

    import SwbShopDeviceRecList from './ShopDeviceRecList'

    Vue.regist(SwbShopDeviceRecList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //
    export default {
        name: 'swb-shop-device-patrol-rec-list',
        path: '/shop/device/patrol/rec/list',
        desc: '巡查记录',
        data: function () {
            return {
                confKey: "swb-shop-device-patrol-rec-list",
                queryOnLoad: true,
                tableHeight: 300, //表格高度
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: false, //操作列是否固定

                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                dataList: [],

                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                currComId: null,
                currStaffId: null,
                treeCollapse: true,
                thisComLevel: null,
                thisComId: null,
                thisComName: null,
                includeSubComs: false,
                exportParmas: null,
                shopFlag: false,
                showQuery: true,
                initIncludeSubComs: false,
                lastPageNumber: null,
                tmpNo: null,
                scopeEntity: null,
                mgmtSmlAreaId: null
            }
        },
        created: function () {
            let self = this;
            let tmpNo = this.$route.query.tmpNo || null;
            if (!Utils.isNoB(tmpNo)) {
                this.tmpNo = tmpNo;
            }
            this.pageSize = this.pageSizes.first();
            //
            this.getCurrUserInfo();
        },

        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="head-block"],[name="tree-block"],[name="query-sort-block"],[name="btn-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                if (!Utils.isNoB(this.tmpNo)) {
                    query_model_ctrl.updateFields({
                        tmpNo: {
                            value: this.tmpNo
                        }
                    });
                }
                query_model_ctrl.updateFields({
                    onlyPost: {
                        value: true
                    }
                });
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField("ownerComTagId", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'imgs': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.imgList != null && row.imgList.length > 0) {
                            for (let i = 0; i < row.imgList.length; i++) {
                                let img = row.imgList[i];
                                domHtml = domHtml + '<a name="imgshow_' + i + '"><img style="height: 36px;width: 36px" src="' + img.fileBrowseUrl + '" title="' + img.imgTitle + '"/></a>';
                            }
                        }
                        return domHtml;
                    },
                    'temperExpt': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.temperFlag) {
                            if (row.temperExpt) {
                                return '<span class="font-red">异常</span>';
                            } else {
                                return '<span class="font-green">正常</span>';
                            }
                        }
                    },
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'imgs': function (row, colName, colValue, rowIndex, btnName) {
                        let index = btnName.split('_')[1];
                        self.viewImage(row.imgList[index].fileBrowseUrl);
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getCurrUserInfo() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                        self.currComId = scopeEntity.comId;
                        self.currStaffId = scopeEntity.staffId;
                        self.shopFlag = scopeEntity.shopFlag;
                        //
                        self.thisComLevel = scopeEntity.comLevel;
                        self.thisComId = scopeEntity.comId;
                        self.thisComName = scopeEntity.comName;
                        self.includeSubComs = false;
                    }
                });
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            getDataList() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if (self.includeSubComs) {
                    filterItems["ownerComId" + self.thisComLevel] = self.thisComId;
                } else {
                    filterItems.ownerComId = self.thisComId;
                }
                filterItems.mgmtSmlAreaId = self.mgmtSmlAreaId;
                filterItems.alreadyDone = true;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                self.exportParmas = filterItems;
                //
                let theLoading = MsgBox.loading();
                shopDevcApi.getDevicePatrolRecList(postData, function (result) {
                    theLoading.close();
                    if (result.type === "info") {
                        self.dataList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(result.data.rows, pagination);

                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getDataList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getDataList();
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            checkComCatChange: function (eventData) {
                this.mgmtSmlAreaId = null;
                if (Utils.isTrue(eventData.mgmtFlag)) {
                    let scopeEntity = this.scopeEntity;
                    this.thisComLevel = scopeEntity.comLevel;
                    this.thisComId = scopeEntity.comId;
                    this.includeSubComs = true;
                    this.mgmtSmlAreaId = eventData.id;
                } else {
                    if (eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                        this.thisComLevel = eventData.level;
                        this.thisComId = eventData.id;
                        this.thisComName = eventData.name;
                        this.includeSubComs = eventData.includeSubComs;
                    }
                }
                this.getDataList();
            },
            // 查看图片详情
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            doExport: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(this.totalCount / pageSize);
                if (pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if (ok) {
                            if (range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages) {
                let pages = Math.ceil(this.totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for (let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "设备巡查记录" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '设备巡查记录-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize) {
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                let cols = tableData.cols || [];
                for (let i = cols.length - 1; i >= 0; i--) {
                    let col = cols[i];
                    if (col.name == "imgs") {
                        cols.splice(i, 1);
                    }
                }
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/shop/devc/patrol/rec/list/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData() {
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let postData = {};
                filterItems.exportFlag = true;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDevicePatrolRecList.vue